module.exports = __webpack_public_path__ + "img/quests.6d257800.png";